import { useCallback } from 'react';
import { SubjectStopForm } from '@mark43/cad-api';
import { FieldErrors, Resolver } from 'react-hook-form';
import { MAXIMUM_DURATION } from './constants';
import { getValidationError } from './helpers';
import { useNow } from '../common/hooks/use-now';

export function useEventSubjectDataFormResolver(): Resolver<SubjectStopForm> {
    const now = useNow();

    return useCallback(
        async (form) => {
            const errors: FieldErrors<SubjectStopForm> = {};

            if (form.duration && form.duration > MAXIMUM_DURATION) {
                errors.duration = getValidationError(`Duration cannot exceed ${MAXIMUM_DURATION}`);
            }

            if (form.stopDateUtc) {
                const stopDateInMilliseconds = new Date(form.stopDateUtc).getTime();
                const eventCreationDateInMilliseconds = new Date(
                    form.eventCreatedDateUtc
                ).getTime();

                if (stopDateInMilliseconds > now) {
                    errors.stopDateUtc = getValidationError('Cannot be future date');
                }

                if (stopDateInMilliseconds < eventCreationDateInMilliseconds) {
                    errors.stopDateUtc = getValidationError(
                        'Cannot be earlier than event creation'
                    );
                }
            }

            if (Object.keys(errors).length > 0) {
                return {
                    values: {},
                    errors,
                };
            } else {
                return {
                    values: form,
                    errors: {},
                };
            }
        },
        [now]
    );
}
